import React from 'react';
import './index.css';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Certifications from './components/Certifications';
import SpokenLanguages from './components/SpokenLanguages';
import Contact from './components/Contact';

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 2rem' }}>
        <Stats />
      </div>
      <Experience />
      <Projects />
      <Skills />
      <Certifications />
      <SpokenLanguages />
      <Contact />
    </>
  );
}
